import React from "react";
import Header from "./Header";

function Layout({ children,subHeader }) {
    return (<React.Fragment>
        <Header />
        {subHeader && subHeader}
        {children}
    </React.Fragment>);
}

export default Layout;